<template>
    <v-container class="app-page-container">
        <div v-if="teacher_course_list" class="pa-2" fluid grid-list-sm >      
        <div v-for="(course, index) in teacher_course_list" v-bind:key="index" @click="populateCourse(index)">
            <v-card class="shadow-none app-page-card">
                <v-card-title style="background-color: primary">
                    <v-flex xs1 ><v-icon @click="deleteCourse(index)" large>delete</v-icon></v-flex>
                    <v-flex xs5 >{{course.area_name}} ({{course.course_name}})</v-flex>
                    <v-flex xs2 ><v-icon @click="showCourse(course.id,0)" >remove_red_eye</v-icon></v-flex>
                  <!--   <v-flex xs4 >
                        <v-btn x-small @click="prepareGroups(index)">Show groups</v-btn>                        
                        <v-btn @click="addGroup(index)">mdi-plus-circle-outline</v-btn>                                                
                        <v-btn @click="deleteCourse(index)" class="icon-close">Delete my course</v-btn>                                               
                    </v-flex>  -->  
                </v-card-title >
                <v-card-text v-if="populated == index"> 
                    <v-layout row wrap v-for="(group, index2) in course.groups" :key="index2" >
                        <v-flex xs1></v-flex>
                        <v-flex xs1>
                            <v-icon @click="deleteGroup(index,index2)">delete</v-icon>

                        </v-flex>
                        <v-flex xs4>
                            <!-- <v-btn v-if="group.active == 0" x-small>archive group</v-btn> -->
                            {{group.group_name}} </v-flex>
                        <v-flex xs2>
                                <v-icon small @click="showCourse(course.id,group.id)">remove_red_eye</v-icon>
                        </v-flex>                              
                        <v-flex xs4>
                                <!-- <v-btn x-small @click="setGroupAsOld(index,index2)">archive</v-btn> -->
                                
                        </v-flex>  
                    </v-layout>        
                    <v-layout row wrap>                   
                        <v-flex xs2></v-flex>
                        <v-flex xs9>                            
                                <v-combobox
                                    v-model="groups1"
                                    :items="group_list1"
                                    :search-input.sync="search1"
                                    hide-selected
                                    label="Add groups"
                                    multiple                        
                                    small-chips
                                    @change="addGroupToCourse(course.id)"
                                    @focus="prepareGroupList()"
                                ></v-combobox>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </div>
        </div>
        <v-card class="shadow-none app-page-card">
            <v-card-text>              
                <v-btn class="btn-style btn-primary" @click="prepareCourses()"><v-icon size="large" >mdi-plus-circle-outline</v-icon>Add course</v-btn>                 
                <v-card v-if = "showCourses" class="shadow-none app-page-card mt20">   
                    <v-card-title color = "blue" >
                        List of courses
                        <v-icon @click="showCourses = false" class="btn-close">close</v-icon>
                    </v-card-title>                 
                    <v-card-text>
                    <v-layout row wrap v-for="(element, index) in course_list" :key="index">
                        <v-flex xs1> </v-flex>
                        <v-flex xs7> 
                          <p :style="getStyle(index)" @click="courseToTeacher(index)"> {{element.area_name}} - {{element.course_name}} </p>
                        </v-flex>
                    </v-layout>
                    </v-card-text>
                </v-card>
            </v-card-text>  
        </v-card>
        
    </v-container>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            info : [],
            populated: -1,
            selection: 'active',
            course_list: null,
            group_list: null,
            teacher_course_list: null,
            filterType: 0,
            showCourses: false,
            showGroups: false,
            addingGroup: false,
            choosingGroup: false,
            addCourseIndex: -1,
            groupName: '',
            groupKey: '',
            groupType: 0,
            privateParams: false,
            groupForCheck: null,
            feedback: '',
            groupIndex: -1,
            teaching_groups: null,
            group_list1: [],
            groups1 :[],
            search1: ''
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setBreadCrumbs',[{text: 'Teacher dashboard', href: '/teacher_dashboard'}])//#
            this.$store.commit('setFeedback', null)   
            // get category list
            axios.get('/get-teacher-courses', this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    this.teacher_course_list = res.data.list
                    axios.get('/get-teaching-groups', this.$store.getters.getAxiosConfig)
                    .then(res2 => {
                        this.teaching_groups = res2.data.teach_groups
                    })
                    .catch(error2 => {
                        this.$store.commit('setFeedback', error2)
                    }) 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 

        },
        prepareGroupList() {
            this.group_list1 = []
            for(let i = 0; i<this.teaching_groups.length; i++){                
                this.group_list1.push(this.teaching_groups[i].name)
            }
            // delete if in list for course
            for(let i = 0; i<this.teacher_course_list[this.populated].groups.length; i++){         
                const index = this.group_list1.indexOf(this.teacher_course_list[this.populated].groups[i].group_name)
                if (index >-1)
                    this.group_list1.splice(index,1)
            }
        },
        prepareCourses() {
            this.course_list = null
            axios.get('/get-courses-for-teacher', this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    // eslint-disable-next-line
                    // console.log(res.data)
                    this.course_list = res.data.list
                    this.showCourses = true
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                     
        }, 
        courseToTeacher(index) {
            // frontend
            this.teacher_course_list.push( 
                this.course_list[index]
            )    
            this.teacher_course_list[this.teacher_course_list.length-1].groups = []
            // backend
            let _data= {
                // techer_id:  - to mam
                course_id: this.course_list[index].id,                
            }

            axios.post('/add-teacher-group', _data, this.$store.getters.getAxiosConfig )
            .then(() => {
            // set data to var               
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })

            this.course_list.splice(index,1)
        },
        deleteCourse(index) {
            this.$store.commit('setFeedback', null)    
            if (this.teacher_course_list[index].groups.length > 0) {
                this.$store.commit('setFeedback', 'Course contains groups')  
                return
            }
            let _data = {
                course_id : this.teacher_course_list[index].id
            }
            axios.post('/delete-teacher-course', _data, this.$store.getters.getAxiosConfig )
            .then(res => {
                // set data to store
                if (res.data.message != "success") {
                    this.$store.commit('setFeedback', res.data.message)  
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })        
        },
        showCourse(cid,gid) {
            this.$router.push({name:'teacher_students', params: {course_id: cid, group_id: gid}}) 
        },

        deleteGroup(index, index2) {
            this.$store.commit('setFeedback', null)  
            let _data = {
                group_id: this.teacher_course_list[index].groups[index2].id,
                course_id : this.teacher_course_list[index].id     
            }
           axios.post('/delete-group-from-course', _data, this.$store.getters.getAxiosConfig )
            .then((res) => {            
                if (res.data.message != "success") {
                    this.$store.commit('setFeedback', res.data.message)  
                } else {
                    // delete from groups
                    this.teacher_course_list[index].groups.splice(index2,1)                   
                }
           })
           .catch(error => {
               this.$store.commit('setFeedback', error)
           })   
        },

        populateCourse(index) {
           // if (!this.showGroups)
                this.populated = index; 
        },
        getStyle(index) {
            return "color:" + this.course_list[index].area_color +"; cursor:pointer;"
        },
        addGroupToCourse() {
            this.feedback = ''

            const _group = this.groups1[0]
            this.groups1 = []
            var _id = 0
            for(let i=0; i<this.teaching_groups.length; i++) {
                if (this.teaching_groups[i].name == _group) {
                     _id = this.teaching_groups[i].id
                     break
                }
            }
            if (_id == 0) return

            let _data = {
                group_id: _id,
                course_id : this.teacher_course_list[this.populated].id     
            }
           axios.post('/add-group-to-course', _data, this.$store.getters.getAxiosConfig )
            .then((res) => {            
                if (res.data.message != "OK") {
                    this.feedback = res.data.message  
                } else {
                    // add to courses
                    this.teacher_course_list[this.populated].groups.push ( { id : _id, group_name :_group })
                    this.prepareGroupList()
                }
           })
           .catch(error => {
               this.$store.commit('setFeedback', error)
           })                      
        }
    }
    
}
</script>


<style>

</style>
